var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.1 Search results loading"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1146,
    transform: "translate(-293 -27)",
    fill: "#F5F5FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Header/movies"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 94,
    transform: "translate(-293 -27)",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M26.8779 24.9939L32.9863 27.4906C34.1463 27.9639 35.4163 27.1122 35.4163 25.8589V14.7939C35.4163 13.5406 34.1463 12.6872 32.9863 13.1606L26.8779 15.6572",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5063 31.9014H20.9547C24.5947 31.9014 26.878 29.5297 26.878 26.1714V14.4797C26.878 11.1214 24.6047 8.74969 20.9547 8.74969H10.5063C6.85467 8.74969 4.58301 11.1214 4.58301 14.4797V26.1714C4.58301 29.5297 6.85467 31.9014 10.5063 31.9014Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.122c503ec55a6a9b28b59944d95d6df1.svg";
export { ForwardRef as ReactComponent };